<div class="mb-button">
  <button
    class="btn btn-primary d-block d-lg-none select-blowers"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasSidenav"
    aria-controls="offcanvasSidenav">
    Select Blower
  </button>
</div>
<div class="container custom">
  <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSidenav" aria-labelledby="offcanvasSidenavLabel">
    <div class="offcanvas-body">
      <app-product-sidenav></app-product-sidenav>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3 d-none d-lg-block sidenav">
      <div class="card card-body navbar">
        <app-product-sidenav></app-product-sidenav>
      </div>
    </div>

    <div class="col-lg-9 bg-content-body product-content product-details-right-panel">
      <div class="tabs-header">
        <div class="tile-name">
          <h5 class="title fw-bold text-primary">Turbo Blower Systems</h5>
        </div>
      </div>
      <div class="card card-body">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
